export const API_KEY = '4j3Gn8Ef6wRe5OnS4RV0RXVMAXdtV8aM';
export const API_URL = 'https://api.giphy.com/v1'